"use strict";

export function initInScope ($scope) {

    $.getScript("/static/js/libs/summernote-lite.js").done(function() {
        let $editor = $scope.find('.js-summernote-editor');

        $editor.each(function () {
            $editor.summernote({
                callbacks: {
                    onPaste: function (e) {
                        let bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                        e.preventDefault();
                        setTimeout(function(){
                            document.execCommand('insertText', false, bufferText);
                        }, 10);
                    }
                },
                tooltip: false,
                height: 200,
                toolbar: [
                    // [groupName, [list of button]]
                    ['style', ['bold', 'italic']],
                    ['para', ['ul', 'ol']],
                    ['misc', ['undo', 'redo']],
                    ['font', ['underline']]
                ]
            });

            let previewText = $(this).attr('data-preview');

            $(this).summernote('code', previewText);
        });
    });
}